// extracted by css-extract-rspack-plugin
var _1 = "column-name-ZxhmgY";
var _2 = "column-name-ZxhmgY";
var _3 = "details-XLhEzo";
var _4 = "filter-iC2bjp";
var _5 = "findingStatisticsAction-PZ_AfP";
var _6 = "projectType-JSUxh0";
var _7 = "table-Gvi1oj";
var _8 = "versionsTitle-AT_bzl";
export { _1 as "column-name", _2 as "columnName", _3 as "details", _4 as "filter", _5 as "findingStatisticsAction", _6 as "projectType", _7 as "table", _8 as "versionsTitle" }
